import ClickOutside from 'click-outside-vue3';

const clickOutside = ClickOutside.directive;

export { clickOutside };
